import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import React from 'react';
import Markdown from 'markdown-to-jsx';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { useTranslation } from '@i18n';
import { serverUrl } from '@globalConfig';
import AddCarToCompare from "@/_MiniApps/CarCompare/Components/AddCarToCompare";
import ModernCardHeader from './ModernCardHeader';
import useHelpers from "@hooks/useHelpers";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { useCarCompareContext } from "@/_MiniApps/CarCompare/CarCompare";
// @ts-ignore

import { twMerge } from "tailwind-merge";
import { unbxdAnalytics } from "@/redux/actions/unbxdActions";
import ModernCardTags from "@/components/SearchComponent/ModernCard/ModernCardTags";
import useIsWebView from "@hooks/useIsWebview";
import useWebview from "@hooks/useWebview";
import { useTamaraWidget } from "@hooks/useTamaraWidget";
import { checkFeatureFlag, checkTestFlag } from "@/common/config/websiteConfig";
import { useLang } from "@/common/Contexts/LanguageContext";
import { If } from "@componentsShared/Conditional/If";
// Helper function to check if running in webview

var ModernCard = function ModernCard(_ref) {
  var _post$bnpl_options;
  var post = _ref.post,
    _ref$isEager = _ref.isEager,
    isEager = _ref$isEager === void 0 ? false : _ref$isEager,
    showGrantedPopup = _ref.showGrantedPopup,
    metaData = _ref.metaData,
    page = _ref.page,
    rank = _ref.rank,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$referralLocation = _ref.referralLocation,
    referralLocation = _ref$referralLocation === void 0 ? null : _ref$referralLocation,
    _ref$fromHomePage = _ref.fromHomePage,
    fromHomePage = _ref$fromHomePage === void 0 ? false : _ref$fromHomePage,
    _ref$isRecommendation = _ref.isRecommendations,
    isRecommendations = _ref$isRecommendation === void 0 ? false : _ref$isRecommendation,
    _ref$sectionType = _ref.sectionType,
    sectionType = _ref$sectionType === void 0 ? 'listing' : _ref$sectionType,
    _ref$is_rec = _ref.is_rec,
    is_rec = _ref$is_rec === void 0 ? false : _ref$is_rec,
    _ref$HasImageSlider = _ref.HasImageSlider,
    HasImageSlider = _ref$HasImageSlider === void 0 ? true : _ref$HasImageSlider,
    _ref$hideFavIcon = _ref.hideFavIcon,
    hideFavIcon = _ref$hideFavIcon === void 0 ? false : _ref$hideFavIcon,
    _ref$showGrantedLabel = _ref.showGrantedLabel,
    showGrantedLabel = _ref$showGrantedLabel === void 0 ? true : _ref$showGrantedLabel,
    _ref$showTags = _ref.showTags,
    showTags = _ref$showTags === void 0 ? true : _ref$showTags,
    _ref$showMarketingLab = _ref.showMarketingLabel,
    showMarketingLabel = _ref$showMarketingLab === void 0 ? true : _ref$showMarketingLab,
    _ref$showDiscountLabe = _ref.showDiscountLabel,
    showDiscountLabel = _ref$showDiscountLabe === void 0 ? true : _ref$showDiscountLabe,
    _ref$slideOnlyOnArr = _ref.slideOnlyOnArr,
    slideOnlyOnArr = _ref$slideOnlyOnArr === void 0 ? false : _ref$slideOnlyOnArr,
    _ref$isAnchor = _ref.isAnchor,
    isAnchor = _ref$isAnchor === void 0 ? false : _ref$isAnchor,
    _ref$titleTag = _ref.titleTag,
    titleTag = _ref$titleTag === void 0 ? "h2" : _ref$titleTag,
    linkTarget = _ref.linkTarget,
    _ref$additionalLinkPa = _ref.additionalLinkParams,
    additionalLinkParams = _ref$additionalLinkPa === void 0 ? {} : _ref$additionalLinkPa;
  var _useTranslation = useTranslation(['web_search']),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var location = useLocation();
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var isBrowseSearch = location.pathname.includes("/autos") || fromHomePage;
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn;
  var _useCarCompareContext = useCarCompareContext(),
    isCarIncludedToCompare = _useCarCompareContext.isCarIncluded,
    isCompareBarAllowed = _useCarCompareContext.isCompareBarAllowed;
  var TitleComp = titleTag;
  var inWebView = useIsWebView();
  var webview = useWebview();
  var lang = useLang();
  var _useTamaraWidget = useTamaraWidget({
      type: "tamara-summary"
    }),
    TamaraWidget = _useTamaraWidget.TamaraWidget,
    ready = _useTamaraWidget.ready;
  if (location.pathname.includes("/deal")) {
    referralLocation = "offerpage";
  }
  var listing_type = referralLocation ? referralLocation : searchParams.get("text") ? "search" : isBrowseSearch ? "browse" : "filter";
  var modifiedLink = createUrl(post === null || post === void 0 ? void 0 : post.product_url);
  var hashParams = _objectSpread(_objectSpread(_objectSpread({}, page && rank && listing_type && {
    page_number: page,
    product_position: rank,
    listing_type: listing_type,
    logged_in: isLoggedIn
  }), is_rec && rank && {
    is_rec: 1,
    product_position: rank,
    logged_in: isLoggedIn
  }), sectionType && {
    section_type: sectionType
  });
  var hashString = Object.keys(hashParams).length > 0 ? '#' + Object.entries(hashParams).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    return "".concat(key, "=").concat(value);
  }).join('&') : '';

  // If additionalLinkParams is provided, convert it to a query string
  var additionalParamsString = Object.keys(additionalLinkParams).length > 0 ? Object.entries(additionalLinkParams).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      key = _ref5[0],
      value = _ref5[1];
    // if value is the first element add ? before the key
    if (modifiedLink.includes('?')) {
      return "".concat(key, "=").concat(value);
    } else {
      return "?".concat(key, "=").concat(value);
    }
  }).join('&') : '';
  var toLink = "".concat(modifiedLink).concat(additionalParamsString).concat(isRecommendations && rank ? "&rank=".concat(rank) : "").concat(hashString);

  // Handle webview navigation
  var handleWebViewNavigation = function handleWebViewNavigation(e) {
    e.preventDefault();
    e.stopPropagation();
    var deepLinkUrl = "".concat(serverUrl, "/cardetail/").concat(post.id);
    if (inWebView) {
      webview.openDeepLink(deepLinkUrl)["catch"](function () {
        // Fallback: you could implement navigateTo here if available
        console.log('WebView deep link failed, fallback needed');
      });
    }
  };
  var renderTamaraWidget = function renderTamaraWidget() {
    if (checkTestFlag("TEST_ENABLE_TAMRA_WIDGET") !== undefined) {
      return checkTestFlag("TEST_ENABLE_TAMRA_WIDGET");
    }
    if (checkFeatureFlag("FF_ENABLE_TAMRA_WIDGET")) {
      return post === null || post === void 0 ? void 0 : post.has_tamara;
    }
    return false;
  };
  // Determine tag and props based on webview status
  var Tag = inWebView ? "div" : isAnchor ? "a" : Link;
  var linkProps = inWebView ? {
    onClick: handleWebViewNavigation
  } : isAnchor ? _objectSpread({
    href: toLink
  }, linkTarget === '_blank' ? {
    target: "_blank",
    rel: "noopener noreferrer"
  } : {}) : {
    to: toLink
  };
  return /*#__PURE__*/React.createElement("div", {
    className: twMerge("relative bg-white rounded-lg overflow-hidden shadow-md w-full cursor-pointer hover:shadow-lg h-full flex flex-col border-2 border-solid border-neutral-10 duration-200 transition-all", isCarIncludedToCompare(parseInt(post.id)) && isCompareBarAllowed() ? "border-2 border-primary border-solid" : ""),
    onClick: function onClick() {
      var params = {
        action: "click",
        query: searchParams.get("text") || "",
        pid: post.uniqueId,
        url: serverUrl + location.pathname + location.search,
        page: (metaData === null || metaData === void 0 ? void 0 : metaData.category_path) || "",
        page_type: metaData !== null && metaData !== void 0 && metaData.category_path ? "BOOLEAN" : ""
      };
      if (!isBrowseSearch || !(metaData !== null && metaData !== void 0 && metaData.category_path)) {
        // delete params.query;
        delete params.page;
        delete params.page_type;
      }
      if (isBrowseSearch && metaData !== null && metaData !== void 0 && metaData.category_path) {
        delete params.query;
      }
      unbxdAnalytics(params);
      _onClick && _onClick();
    },
    id: "modern-card_post-".concat(post.id)
  }, /*#__PURE__*/React.createElement(ModernCardHeader, {
    post: post,
    isEager: isEager,
    to_link: toLink,
    rank: rank,
    HasImageSlider: post.images_urls && post.images_urls.length > 1 && HasImageSlider,
    hideFavIcon: hideFavIcon,
    showMarketingLabel: showMarketingLabel,
    showDiscountLabel: showDiscountLabel,
    slideOnlyOnArr: slideOnlyOnArr,
    isAnchor: isAnchor,
    linkTarget: linkTarget,
    inWebView: inWebView,
    onWebViewClick: handleWebViewNavigation
  }), /*#__PURE__*/React.createElement(Tag, _extends({}, linkProps, {
    id: "posts-card-body-".concat(post.id),
    className: "p-3 !h-full flex flex-col justify-between"
  }), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement(TitleComp, {
    id: "posts-card-title-".concat(post.id),
    className: "text-gray-text text-sm font-bold mb-3 text-start"
  }, post.title), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-stretch gap-0.5 flex-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: twMerge("border border-solid border-[#F7F8F9] rounded overflow-hidden w-[calc(50%-1px)]", !(post !== null && post !== void 0 && post.monthly_installment) && "w-full")
  }, /*#__PURE__*/React.createElement("div", {
    id: "posts-card-cash-price-".concat(post.id),
    className: "border-r-2 border-solid border-success py-1 px-1.5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "font-semibold text-neutral-100 text-xs"
  }, tShort("modern_card/cash_price", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-[#5E6E80] text-[8px] font-semibold"
  }, tShort("modern_card/tax_included", {
    ns: "web_common"
  }))), post.sellingprice && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1 text-success leading-6"
  }, /*#__PURE__*/React.createElement("span", {
    className: "font-bold leading-6 text-fluid-sm"
  }, post.sellingprice), /*#__PURE__*/React.createElement("span", {
    className: "text-lg leading-4"
  }, t("sar", {
    ns: "web_search"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "text-gray-500 text-xs leading-3 ".concat(!(post !== null && post !== void 0 && post.drop_price) ? 'invisible' : '')
  }, /*#__PURE__*/React.createElement("span", {
    className: "font-bold leading-3 text-xs"
  }, /*#__PURE__*/React.createElement("span", {
    className: " relative inline-block after:content-[''] after:absolute after:left-0 after:right-0 after:top-1/2 after:h-px after:bg-gray-500 after:-translate-y-1/2 "
  }, post === null || post === void 0 ? void 0 : post.drop_price)), /*#__PURE__*/React.createElement("span", {
    className: "font-medium leading-3 text-xs"
  }, t("sar", {
    ns: "web_search"
  }))))), /*#__PURE__*/React.createElement(If, {
    condition: post.monthly_installment
  }, /*#__PURE__*/React.createElement("div", {
    className: "border border-solid border-[#F7F8F9] rounded overflow-hidden flex-1 w-[calc(50%-1px)]"
  }, /*#__PURE__*/React.createElement("div", {
    id: "posts-card-finance-price-".concat(post.id),
    className: "border-r-2 border-solid border-primary py-1 px-1.5 h-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-xs font-semibold text-neutral-100"
  }, tShort("modern_card/finance_title", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1 en:gap-px"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1 text-primary leading-6"
  }, /*#__PURE__*/React.createElement("span", {
    className: "leading-6 font-bold text-fluid-sm"
  }, post.monthly_installment)), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-px leading-4"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-primary text-lg leading-4"
  }, t("sar", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-primary text-sm"
  }, "/"), /*#__PURE__*/React.createElement("span", {
    className: "text-primary text-sm"
  }, tShort("modern_card/month", {
    ns: "web_common"
  }))))))))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, showTags && post.tags && post.tags.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModernCardTags, {
    tags: post.tags,
    className: !showGrantedLabel && "mb-0"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "w-full h-px bg-[#E9E9E9]"
  }), /*#__PURE__*/React.createElement("div", {
    id: "posts-card-footer-".concat(post.id),
    className: "flex items-center justify-between"
  }, showGrantedLabel && post !== null && post !== void 0 && post.warranty_tag ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "pt-2 border-b border-[#E9E9E9] border-b-solid"
  }, /*#__PURE__*/React.createElement("div", {
    id: "posts-card-warranty-".concat(post.id),
    className: twMerge("rounded-md py-1 px-1 flex justify-center cursor-default items-center gap-1 text-xs max-w-fit", showGrantedPopup && "cursor-pointer"),
    style: {
      backgroundColor: post.warranty_tag.background_color,
      color: post.warranty_tag.text_color
    },
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      showGrantedPopup && showGrantedPopup();
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: post.warranty_tag.icon,
    width: 16,
    height: 16,
    alt: "warranty",
    "aria-label": "warranty"
  }), /*#__PURE__*/React.createElement("div", {
    className: "[&>strong]:font-bold"
  }, /*#__PURE__*/React.createElement(Markdown, null, post.warranty_tag.tag_name))))) : null, /*#__PURE__*/React.createElement("div", {
    id: "posts-card-tamara-".concat(post.id),
    className: "pt-2 flex gap-1",
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, post === null || post === void 0 ? void 0 : (_post$bnpl_options = post.bnpl_options) === null || _post$bnpl_options === void 0 ? void 0 : _post$bnpl_options.map(function (imgUrl, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "cursor-default h-5 w-5"
    }, /*#__PURE__*/React.createElement("img", {
      src: imgUrl,
      className: "w-auto h-5",
      alt: "bnpl-option-".concat(index)
    }));
  }))))), /*#__PURE__*/React.createElement("div", {
    id: "posts-card-compare-wrapper-".concat(post.id),
    className: "px-3"
  }, /*#__PURE__*/React.createElement(AddCarToCompare, {
    car: post,
    className: "px-0"
  })));
};
export default ModernCard;